import { Component, OnInit } from '@angular/core';
import { sessionStorageKey } from '../sgzp-app5.constants';

@Component({
  selector: 'app-sgzp-app5-change-password-sent',
  templateUrl: './sgzp-app5-change-password-sent.component.html',
  styleUrls: [
    '../style/global.css',
    './sgzp-app5-change-password-sent.component.css'
  ]
})
export class SgzpApp5ChangePasswordSentComponent implements OnInit {
  email: string;
  constructor() {
    this.email = sessionStorage.getItem(sessionStorageKey.passwordResetEmail);
    if (!this.email) {
      history.back();
    }
  }

  ngOnInit(): void {}

  async passwordReset() {
    location.pathname = 'forgot-password';
  }
}
